import { ContentPage } from "components/ContentPage";
import content from 'public/static/rsci.json'

export default function ScientificCatalogRSCI() {
  return <ContentPage wide>
    <h2 style={{ textAlign: 'end' }}>29.07.2025</h2>
    <h1 style={{ textAlign: 'center' }}>Список журналов, входящих в базу данных RSCI</h1>
    <br />
    <br />
    <table>
      <colgroup>
        <col span={1} />
        <col span={1} style={{ width: 100 }} />
        <col span={1} style={{ width: 100 }} />
        <col span={1} />
      </colgroup>
      <thead>
        <tr>
          <th>№</th>
          <th>ISSN</th>
          <th>eISSN</th>
          <th>Наименование журнала</th>
        </tr>
      </thead>
      <tbody>
        {content.slice(1, ).map((row, ri) => <tr key={ri}>
          {row.map((col, rc) => <td key={rc}>{col}</td>)}
        </tr>)}
      </tbody>
    </table>
  <hr/>

  <p>
    <a href="https://www.elibrary.ru/projects/rsci/rsci.pdf" target="_blank" rel="noreferrer">https://www.elibrary.ru/projects/rsci/rsci.pdf</a>.{' '}
      Дата обращения: 20.01.2026
  </p>

  </ContentPage>
}
